<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 payment-methods" id="sales-company">
  <po-widget>
    <span class="po-font-text-bold">Vendas por empresa</span>
  </po-widget>
</div>